/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { useLayout } from '../Layout';
import { startSocket } from '../../components/Layout/SocketHandler/socketInit';
import {
  connectionHandler,
  facebookHandler,
  googleHandler,
  instagramHandler,
  messageHandler,
  modifyMessageStatus,
  notificationHandler,
  appointmentHandler,
} from '../../components/Layout/SocketHandler/controller/socketRouter';

export const SocketContext = createContext({});

let socket;

const SocketContextProvider = ({ children, ...props }) => {
  const history = useHistory();
  const { addNewMessageId } = useLayout();
  const { userId, token, merchantId, newMessages } = props;
  const [storeId, setStoreId] = useState(null);
  const [typers, setTypers] = useState([]);

  useEffect(() => {
    async function initSocket() {
      if (!userId && socket) {
        socket.removeEventListener('message');
        socket.removeEventListener('notify');
        socket.removeEventListener('connecting'); // yeah I dono either if this is required, I had to do it for message and notify to go away
        socket.removeEventListener('connect_failed'); // yeah I dono either if this is required, I had to do it for message and notify to go away
        socket.removeEventListener('connect'); // yeah I dono either if this is required, I had to do it for message and notify to go away
        socket.removeEventListener('disconnect'); // yeah I dono either if this is required, I had to do it for message and notify to go away
        socket.removeEventListener('status'); // yeah I dono either if this is required, I had to do it for message and notify to go away
        socket = null; // because setting it to null was NOT enough to wipe the socket object clean
      }

      if (userId && token && !socket) {
        socket = await startSocket(userId, merchantId, token);

        /* socket.on('connecting', () => {}); */
        /* socket.on('connect_failed', () => {}); */

        socket.on('connect', () => {
          connectionHandler('success', 'Connected');
          console.log('🚀 ~ connect');
        });

        socket.on('disconnect', () => {
          connectionHandler('warning', 'Connection Lost');
          console.log('🚧 ~ disconnect');
        });

        socket.on('message', data => {
          console.log('📩 ~ message', data);
          messageHandler(data, history, { ...props, addNewMessageId }, 'sms');
        });

        socket.on('facebook', data => {
          console.log('📩 ~ facebook', data);
          facebookHandler(data, history, props, 'facebook');
        });

        socket.on('instagram', data => {
          console.log('📩 ~ instagram', data);
          instagramHandler(data, history, props, 'instagram');
        });

        socket.on('google', data => {
          console.log('📩 ~ google');
          googleHandler(data, history, props, 'google');
        });

        socket.on('notify', data => {
          notificationHandler(data);
          console.log('📢 ~ notify', data);
        });

        socket.on('status', data => {
          modifyMessageStatus(data);
          console.log('📊 ~ status', data);
        });

        socket.on('appointment', data => {
          console.log('📩 ~ appointment', data);
          appointmentHandler(data, history, props);

        });

        socket.onAny(event => {
          console.log('🔥 ~ onAny', event);
        });
      }
    }

    initSocket();
  }, [userId, merchantId, token, newMessages]);

  const handleNewData = useCallback(
    data => {
      console.log('👥 ~ typers', data);
      if (data && data?.store?.id === storeId) {
        const findChat = typers.find(typer => typer.id === data.id);
        if (findChat) {
          if (data.typers.length === 0) {
            setTypers(typers.filter(typer => typer.id !== data.id));
          } else {
            setTypers(typers.map(typer => (typer.id === data.id ? { ...typer, typers: data.typers } : typer)));
          }
        } else {
          setTypers([...typers, data]);
        }
      }
    },
    [typers, setTypers, storeId],
  );

  useEffect(() => {
    if (!socket && !storeId) return;
    socket?.emit('joinStore', { store: { id: storeId } });

    socket.on('typers', handleNewData);
  }, [socket, storeId]);

  return <SocketContext.Provider value={{ socket, setStoreId, typers }}>{children}</SocketContext.Provider>;
};

export function useSocket() {
  const context = useContext(SocketContext);

  if (!context) {
    throw new Error('useSocketContext must be used within an SocketContext');
  }
  return context;
}

const mapStateToProps = state => ({
  ...state.auth,
  newMessages: state.navigation.newMessages,
});

export default connect(mapStateToProps)(SocketContextProvider);
